/**
 * Utility functions for formatting data display
 */

/**
 * Format bought count for display
 * @param {number|null|undefined} count - The purchase count to format
 * @returns {string} Formatted count string or empty string if no count
 */
export const formatBoughtCount = (count) => {
  // Handle null, undefined, or 0 values
  if (!count || count === 0) {
    return '';
  }
  
  // Ensure count is a number
  const numCount = Number(count);
  if (isNaN(numCount) || numCount < 0) {
    return '';
  }
  
  // Format based on value ranges
  if (numCount >= 10000) {
    return '10K+';
  }
  
  if (numCount >= 1000) {
    return `${Math.floor(numCount / 1000)}K+`;
  }
  
  return numCount.toString();
};

/**
 * Format date for display
 * @param {string|Date} dateString - The date to format
 * @returns {string} Formatted date string
 */
export const formatDate = (dateString) => {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    
    return date.toLocaleDateString('zh-TW', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
    console.warn('Error formatting date:', error);
    return '';
  }
};

/**
 * Format number with locale-specific formatting
 * @param {number} number - The number to format
 * @returns {string} Formatted number string
 */
export const formatNumber = (number) => {
  if (number === null || number === undefined || isNaN(number)) {
    return '';
  }
  
  return number.toLocaleString('zh-TW');
};